// components/GitLabProjects.js
import React from 'react';
import { Link } from 'react-router-dom';

function GitLabProjects() {
  return (
    <section
      id="gitlab-projects"
      className="bg-slate-900 text-white px-6 py-16 scroll-mt-28"
    >
      <h2 className="text-3xl font-bold mb-10 text-center">Own Projects</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto px-6">
        
        {/* Project 1: ETS Tracking Application */}
        <Link
          to="/vpc-project"
          className="hover:scale-105 transition-transform duration-300 block"
        >
          <div>
            <img
              src="/images/vpc_project.png" // ✅ Make sure this image is in public/images
              alt="ETS Tracking Project Infra"
              className="rounded-lg shadow-lg"
            />
            <h3 className="text-xl font-semibold mt-4">
              ETS Tracking Application
            </h3>
            <p className="text-gray-300 mt-2">
              Full infrastructure setup with Terraform including VPC, subnets,
              EC2, RDS, Load Balancer, and CI/CD for a Java-React app.
            </p>
          </div>
        </Link>

        {/* Project 2: CI/CD Pipeline */}
        <Link
          to="/ci-cd-pipeline"
          className="hover:scale-105 transition-transform duration-300 block"
        >
          <div>
            <img
              src="/images/cicd_pipeline.png" // ✅ Place image in public/images
              alt="CI/CD Pipeline Parameterized "
              className="rounded-lg shadow-lg"
            />
            <h3 className="text-xl font-semibold mt-4">
              CI/CD Parameterized Pipeline Project
            </h3>
            <p className="text-gray-300 mt-2">
              Automated build, test, and deployment pipeline using GitLab CI/CD
              for a cloud-hosted application.
            </p>
          </div>
        </Link>

      </div>
    </section>
  );
}

export default GitLabProjects;
